import { render, staticRenderFns } from "./IdentikitForm.vue?vue&type=template&id=8327174e&scoped=true"
import script from "./IdentikitForm.vue?vue&type=script&setup=true&lang=js"
export * from "./IdentikitForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IdentikitForm.vue?vue&type=style&index=0&id=8327174e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8327174e",
  null
  
)

export default component.exports